import { Component, inject, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LoaderService} from '@services/loader/loader.service';

@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  standalone: true,
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  private loadingService: LoaderService = inject(LoaderService);
  isVisible: Signal<boolean> = this.loadingService.isVisible;
}

